import { Badge } from '@/modules/ui/components/badge/Badge';

interface UserRolesTagProps {
  roles: string[];
}

export const UserRolesTag = ({ roles }: UserRolesTagProps) => {
  return (
    <div className="flex flex-wrap gap-2">
      {roles.map((role) => (
        <Badge key={role} variant="secondary">
          {role}
        </Badge>
      ))}
    </div>
  );
};
